const hotel = {
  availableMealPlans: "利用可能な食事プラン", // translated
  availableRoomsTypes: "利用可能な部屋タイプ", // translated
  cancellationPolicy: "取り消し規約", // translated
  cancellationRules: "キャンセル規定", // translated
  freeCancellationAvailable: "無料キャンセル可能", // translated
  nonRefundable: "返金不可", // translated
  priceFor: "価格", // translated
  nights: "夜", // translated
  totalPrice: "合計金額", // translated
  seeAvailability: "利用可能状況を参照", // translated
  myProfile: "私のプロフィール", // translated
  travelTrust: "トラベルトラスト", // translated
  signIn: "サインイン", // translated
  searchNow: "検索中", // translated
  policy: "ポリシー", // translated
  cxlRules: "CXL ルール", // translated
  room: "部屋", // translated
  cxlPolicy: "CXL ポリシー", // translated
  beddingType: "寝具の種類", // translated
  hotelName: "ホテル名", // translated
  reservationDate: "予約日", // translated
  maxPax: "マックス・パックス", // translated
};



export default hotel;
